import React, { useEffect } from 'react';

const RefundPolicyPage = () => {
  useEffect(() => {
    document.title = 'Refund & Replacement Policy | PosterFire';
    window.scrollTo(0, 0);
    return () => { document.title = 'PosterFire — Premium Posters, Wall Art & Home Decor'; };
  }, []);

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12" data-testid="refund-policy-page">
      <h1 className="text-3xl sm:text-4xl font-heading font-bold text-white mb-2">Refund & Replacement Policy</h1>
      <p className="text-sm text-white/50 mb-10">Effective date: Jan 15, 2023 &mdash; PosterFire ("we," "us," "our")</p>

      <div className="space-y-8 text-white/80 leading-relaxed">

        <section>
          <h2 className="text-lg font-bold text-white mb-2">1. All Sales Final (With a Damage Exception)</h2>
          <p>Because our posters are printed and packed for each order, <strong className="text-white">all sales are final</strong>. We only offer a replacement or refund if your poster arrives damaged.</p>
        </section>

        <section>
          <h2 className="text-lg font-bold text-white mb-2">2. Damage Claims (Required Proof)</h2>
          <p className="mb-3">To qualify for a refund or replacement, you must email us within <strong className="text-white">48–72 hours</strong> of delivery at <a href="mailto:support@posterfire.com" className="text-fire hover:underline">support@posterfire.com</a> with:</p>
          <ul className="list-disc pl-6 space-y-1.5">
            <li>Your order number</li>
            <li>Clear photos of:
              <ul className="list-disc pl-6 mt-1 space-y-1">
                <li>The damaged poster (close-up and full view)</li>
                <li>The packaging (including any damage)</li>
                <li>The shipping label on the package</li>
              </ul>
            </li>
          </ul>
          <p className="mt-3 text-sm text-white/60">If the photos don't clearly show the damage and packaging, we may request additional images.</p>
        </section>

        <section>
          <h2 className="text-lg font-bold text-white mb-2">3. What We'll Do If It's Damaged</h2>
          <p className="mb-3">After we review and approve your claim, we will provide one of the following (at our discretion):</p>
          <ul className="list-disc pl-6 space-y-1.5">
            <li>A <strong className="text-white">free replacement</strong> shipped to you, or</li>
            <li>A <strong className="text-white">refund</strong> to the original payment method</li>
          </ul>
          <p className="mt-3 text-sm text-white/60">If a refund is issued, processing time depends on your bank/payment provider (typically 5–10 business days).</p>
        </section>

        <section>
          <h2 className="text-lg font-bold text-white mb-2">4. Not Eligible for Refund/Replacement</h2>
          <p className="mb-3">We cannot accept refunds or replacements for:</p>
          <ul className="list-disc pl-6 space-y-1.5">
            <li>"Changed my mind" / no longer want it</li>
            <li>Wrong size selected at checkout</li>
            <li>Minor variations in color due to screen settings/lighting</li>
            <li>Damage caused after delivery (improper handling, mounting, humidity, etc.)</li>
            <li>Orders shipped to an incorrect address provided by the customer</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-bold text-white mb-2">5. Shipping Issues (Lost, Stolen, or Delayed)</h2>
          <p>If your package shows as delivered but you can't find it, contact the carrier first and then email us at <a href="mailto:support@posterfire.com" className="text-fire hover:underline">support@posterfire.com</a>. We'll do our best to assist, but we cannot guarantee refunds for theft or carrier-delivery errors once marked delivered.</p>
        </section>

        <section className="border-t border-white/10 pt-8">
          <h2 className="text-lg font-bold text-white mb-2">6. Contact</h2>
          <p>Refund/replacement requests: <a href="mailto:support@posterfire.com" className="text-fire hover:underline">support@posterfire.com</a></p>
          <p className="text-sm text-white/50 mt-1">(Please include your order number.)</p>
        </section>

      </div>
    </div>
  );
};

export default RefundPolicyPage;
